import bridge from "dsbridge";
export default {
    callSyncMethod(name, data) {
        // callback(bridge.call(name, data, {msg: "callSyn"}));
        let str = bridge.call(name, data);
        return str;
    },
    callAsyncMethod(name, data, callback) {
        // callback(bridge.call(name, data, {msg: "callSyn"}));
        bridge.call(name, data, callback);
    },
    registermethod(tag, callback) {
        bridge.register(tag, callback);
    }
};



// WEBPACK FOOTER //
// ./src/utils/Bridge.js